import { IconsEnum } from 'components/Icons';
import dynamic from 'next/dynamic';

export type BannerInformationPropsType = {
  type?: 'error' | 'success' | 'informative' | 'warning';
  text: string;
  visible: boolean;
  icon?: IconsEnum;
  isDismissible?: boolean;
  actionButton?: {
    element: React.ReactNode;
    onClick: () => void;
  };
  redirectButton?: {
    element: React.ReactNode;
    url: string;
  };
  actionOnDismiss?: () => void;
  layoutType?: 'big' | 'small' | 'onlylabel';
  className?: string;
};

export const BannerInformation = dynamic<BannerInformationPropsType>(
  () => import('components/bannerInformation/BannerInformation').then((mod) => mod.BannerInformation),
  { ssr: false }
);
